import { useEffect, useState } from 'react';

function formatAmount(amount, currency) {
  const dollars = (amount || 0) / 100;
  if (Number.isInteger(dollars)) return `$${dollars}`;
  return `$${dollars.toFixed(2)}`;
}

function intervalLabel(interval) {
  if (!interval) return '';
  if (interval === 'month') return '/mo';
  if (interval === 'year') return '/yr';
  if (interval === 'week') return '/wk';
  return `/${interval}`;
}

function appKeyForProduct(product) {
  const haystack = [
    product.name || '',
    product.description || '',
    JSON.stringify(product.metadata || {}),
  ].join(' ').toLowerCase();
  if (haystack.includes('billboard')) return 'billboard';
  if (haystack.includes('slides') || haystack.includes('slide')) return 'slides';
  return null;
}

function tierFromPrice(price) {
  return {
    id: price.id,
    label: price.nickname || '',
    amount: price.amount,
    currency: price.currency,
    interval: price.interval,
    formatted: `${formatAmount(price.amount, price.currency)}${intervalLabel(price.interval)}`,
  };
}

export function usePricing() {
  const [state, setState] = useState({ loading: true, error: null, byApp: { slides: [], billboard: [] } });

  useEffect(() => {
    let cancelled = false;
    fetch('/billing/available_registration_apps.json', {
      headers: { 'Accept': 'application/json' },
      credentials: 'same-origin',
    })
      .then((res) => res.ok ? res.json() : Promise.reject(new Error(`HTTP ${res.status}`)))
      .then((data) => {
        if (cancelled) return;
        const products = Array.isArray(data) ? data : [];
        const byApp = { slides: [], billboard: [] };
        products.forEach((product) => {
          const key = appKeyForProduct(product);
          if (!key) return;
          const prices = (product.prices || []).map(tierFromPrice).filter((t) => t.amount && t.amount > 0);
          if (!prices.length) return;
          prices.sort((a, b) => a.amount - b.amount);
          byApp[key].push({
            id: product.id,
            name: product.name,
            description: product.description,
            tiers: prices,
            features: Array.isArray(product.features) ? product.features : [],
          });
        });
        setState({ loading: false, error: null, byApp });
      })
      .catch((err) => {
        if (cancelled) return;
        setState({ loading: false, error: err.message || 'Failed to load pricing', byApp: { slides: [], billboard: [] } });
      });
    return () => { cancelled = true; };
  }, []);

  return state;
}
